import { IRewardToken } from '../../reward-tokens.model';
import { TokenValidationInput } from './criteria-validator-base.service';
import { TokenValidatorBase } from './token-validator-base.service';

export abstract class TokenValidator<T extends IRewardToken> extends TokenValidatorBase<T, TokenValidationInput> {
    getBetslipPicksIds(state: TokenValidationInput): string[] {
        return state.allPicks.map(({ id }) => id.toString());
    }
}
